<h2 mat-dialog-title>{{'taskTemplates.option' | translate}}</h2>

<mat-dialog-content>
    <div class="pt-2 pb-3">
        <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >

            <form [formGroup]="optionsForm">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'title' | translate}}</mat-label>
                    <input matInput name="option_title" formControlName="title" class="form-control" placeholder="{{'title' | translate}}" id="option_title" type="text" >
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'content.value' | translate}}</mat-label>
                    <input matInput name="option_value" formControlName="value" class="form-control" placeholder="{{'content.value' | translate}}" id="option_value" type="text" >
                </mat-form-field>
            </form>

        </section>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button style="color:var(--warmOrange);" (click)="onCancel();" >{{'cancel' | translate}}</button>
    <button mat-button class="orange-button" (click)="onSave();" [disabled]="optionsForm.invalid">{{'save' | translate}}</button>
</mat-dialog-actions>
